/* eslint-disable @typescript-eslint/no-explicit-any */
import apiService from './api'
import { sanitizeQueryParams } from '../utility/helpers/apiHelper'
import type { TableSortValue } from "@src/shared/constants/sort-order.constants";


interface Booking {
  id?: string | number
  businessId?: number
  clientId?: number
  staffId?: number
  categoryId?: number
  addons?: number
  date?: string
  time?: string
  locationType?: string
  bookingStatus?: string
  paymentStatus?: string
  totalAmount?: number
  duration?: number
  clientMessage?: string
  referenceImages?: string | string[]
  paymentDetail?: string
}

interface GetBookingsParams {
  page?: number
  pageSize?: number
  search?: string
  bookingStatus?: string
  paymentStatus?: string
  orderBy?: string
  orderDirection?: TableSortValue
  [key: string]: any
}

export class BookingService {
  async getBookings(query: GetBookingsParams) {
    return apiService.get('/bookings', { params: sanitizeQueryParams(query) })
  }

  async getBooking(id: string | number) {
    return apiService.get(`/bookings/${id}`)
  }
}

export const bookingService = new BookingService()
